export enum COLORS {
  GREEN = 'green',
  YELLOW = 'yellow',
}

export enum LIMIT_HOURS {
  GREEN = 16,
  YELLOW = 5,
}
